var map = {
	"./arbitrum-one.svg": "bc86",
	"./arbitrum.svg": "d5bf",
	"./ethereum.svg": "537f",
	"./goerli.svg": "1654",
	"./homestead.svg": "dcd7",
	"./kovan.svg": "5883",
	"./polygon.svg": "95cc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4a7f";